import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { CircularProgress } from '@mui/material';

const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

type Props = {
  large?: boolean;
  children?: ReactNode;
};

export const CenteredLoader: FC<Props> = ({ large, children }) => (
  <LoaderWrapper>
    <CircularProgress size={large ? 80 : 40} />
    {children}
  </LoaderWrapper>
);
